"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));
var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));
var _ShoppingCart = _interopRequireDefault(require("@material-ui/icons/ShoppingCart"));
var _Avatar = _interopRequireDefault(require("../../Avatar"));
var _Item = _interopRequireDefault(require("../components/Item"));
var ReceiptPane = function ReceiptPane(_ref) {
  var title = _ref.title,
    date = _ref.date,
    trackingNumber = _ref.trackingNumber,
    tax = _ref.tax,
    subTotal = _ref.subTotal,
    total = _ref.total,
    items = _ref.items;
  var list = [{
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], {
      fontSize: "small"
    }),
    content: date
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], {
      fontSize: "small"
    }),
    content: trackingNumber
  }].concat((0, _toConsumableArray2["default"])(items.map(function (item) {
    return {
      icon: /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        src: item.image,
        alt: item.name,
        className: "inline-flex !h-10 !w-10 bg-app border",
        fallback: /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-light"
        }, /*#__PURE__*/_react["default"].createElement(_ShoppingCart["default"], null))
      }),
      content: /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "inline-block w-full truncate",
        style: {
          width: '70%'
        }
      }, item.name), /*#__PURE__*/_react["default"].createElement("span", {
        className: "float-right"
      }, item.price))
    };
  })), [{
    icon: /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-14"
    }),
    content: (0, _isNil["default"])(subTotal) ? null : /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-full"
    }, "Subtotal:"), /*#__PURE__*/_react["default"].createElement("span", {
      className: "float-right pl-4"
    }, subTotal))
  }, {
    icon: /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-14"
    }),
    content: (0, _isNil["default"])(tax) ? null : /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-full"
    }, "Tax:"), /*#__PURE__*/_react["default"].createElement("span", {
      className: "float-right pl-4"
    }, tax))
  }, {
    icon: /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-14"
    }),
    content: (0, _isNil["default"])(total) ? null : /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-full"
    }, "Total:"), /*#__PURE__*/_react["default"].createElement("span", {
      className: "float-right pl-4"
    }, total))
  }]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-8 pr-4"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "px-6 text-dark font-bold text-lg truncate"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4"
  }, list.map(function (_ref2, index) {
    var icon = _ref2.icon,
      content = _ref2.content;
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: index,
      size: "sm",
      icon: icon
    }, content);
  })));
};
var _default = exports["default"] = ReceiptPane;
//# sourceMappingURL=Purchase.js.map